export const BRIDGE_KEYS = {
    CONTENT_METADATA_KEY: "contentMetadata",
    MOST_RECENT_RESOURCE: "mostRecentResource",
    COORDINATOR_SERVICE_DATA_KEY: "coordinatorServiceData",
    ABBA_PLATFORM_FEED_BASE_KEY: "abbaPlatformFeed-",
    PERSONALIZATION_ALLOWED: "personalizationAllowed",
    BRIDGE_EXPIRATION_KEY_SUFFIX: "-expiration",
};
